export default "__VITE_ASSET__BkT_vahI__"